var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-card-title",
        { staticClass: "mb-75" },
        [
          _vm._v(" Cambios "),
          _vm.isLoading
            ? _c("b-spinner", {
                staticClass: "float-right",
                attrs: { small: "", variant: "primary" }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "activity-timeline mt-4" },
        [
          _c(
            "app-timeline",
            _vm._l(_vm.items, function(item) {
              return _c("app-timeline-item", {
                key: item.id,
                attrs: {
                  title: item.title,
                  subtitle: item.subtitle,
                  icon: item.icon,
                  time: _vm._f("fromNow")(item.date),
                  variant: item.status
                }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }